import React, { useEffect, useRef, useState } from "react";
import EzTable from "../../../common/EzTable";
import { EzToast, TOAST_SEVERITY } from "../../../common/EzToast";
import EzNotFound from "../../../common/EzNotFound";
import { Box, Container } from "@mui/material";
import Breadcrumb from "../../../common/Breadcrumb";
import { Button } from "primereact/button";
import { useStyles } from "./style";
import { RateAdminBreadcrumb } from "./CreateRateAdminLorAdjustments/constant";
import { printTableData } from "../../../utils/printUtils";

const getIconPath = (imgPathDelta = "/no-record.png") =>
  process.env.PUBLIC_URL + imgPathDelta;
const RateAdminLorAdjustments = (props) => {
  const classes = useStyles();
  const {
    fetchRateAdminLorAdjustmentss,
    tableData,
    setDeleteConfirmationPopupVisibility,
    exportRateAdminLorAdjustments,
    isPageLevelError,
    paginationInfo,
    isLoading,
    screenPermissions,
    handleCreateRateAdminLorAdjustments,
    editRateAdminLorAdjustmentsRoute,
    deleteRateAdminLorAdjustments,
    shouldOpenDeleteConfirmationPopup,
    isRateAdminLorAdjustmentsDeleteSuccess,
    isRateAdminLorAdjustmentsDeleteError,
    savedTableState,
    onTableStateChange,
  } = props;
  const [areFiltersVisible, toggleFilterState] = useState(true);
  const [isCopy, setIsCopy] = useState(false);
  const [isPrintError, setIsPrintError] = useState(false);
  const convertToTSV = (data) => {
    const headers = data.columns.map((item) => item.colLabel).join("\t");
    //const headers = Object.keys(data.rows[0]).join('\t');
    const rows = data.rows
      .map((row) => Object.values(row).join("\t"))
      .join("\n");
    return `${headers}\n${rows}`;
  };

  const copyToClipboard = () => {
    const csv = convertToTSV(tableData);
    navigator.clipboard
      .writeText(csv)
      .then(() => setIsCopy(true))
      .catch((err) => setIsCopy(true));
  };
  useEffect(() => {
    setTimeout(() => setIsCopy(false), 1000);
  }, [isCopy]);
  useEffect(() => {
    if (isPrintError) {
      const timer = setTimeout(() => setIsPrintError(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [isPrintError]);
  const handlePrint = () => {
    const success = printTableData({
      title: "LOR Adjustments",
      columns: tableData?.columns || [],
      rows: tableData?.rows || [],
    });
    if (!success) {
      setIsPrintError(true);
    }
  };
  const renderPageHeaderSection = () => {
    return (
      <div className="make-relative sub-header ">
        <div className="maintitlediv">
          <div className="ml-3">
            <h4 className="pagetitle">Lor Adjustments</h4>
            <Button
              label={areFiltersVisible ? "Advanced Filter" : "Advanced Filter"}
              icon={areFiltersVisible ? "pi pi-filter-slash" : "pi pi-filter"}
              className={`p-button-text p-button-secondary shadow-btn`}
              onClick={() => {
                toggleFilterState(!areFiltersVisible);
              }}
            />
          </div>
          <div className="buttonarea">
            <div className="create-btn-group">
              {screenPermissions?.create && (
                <Button
                  label={"Create Lor Adjustments"}
                  className={` p-button-raised`}
                  style={{ borderRadius: "0px" }}
                  onClick={handleCreateRateAdminLorAdjustments}
                />
              )}
            </div>
            <div className="copy-excel-print-group">
              <Button
                label={"Copy"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={copyToClipboard}
              />
              <Button
                label={"Excel"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={exportRateAdminLorAdjustments}
              />
              <Button
                label={"Print"}
                className={` p-button-raised`}
                style={{ borderRadius: "0px" }}
                onClick={handlePrint}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  const shouldRenderFullPageError = () => isPageLevelError;
  const shouldRenderComplianceRecords = () => tableData?.columns?.length > 0;
  const shouldRenderNotFoundView = () =>
    !shouldRenderComplianceRecords() && !shouldRenderFullPageError();

  // Build initial filters from saved state if available
  const getInitialFilters = () => {
    const defaultFilters = {
      global: { value: null },
      status: { value: null, filterKey: "status" },
      title: { value: null, filterKey: "title" },
      crtBy: { value: null, filterKey: "crtBy" },
      crtTime: { value: null, filterKey: "crtTime" },
      modBy: { value: null, filterKey: "modBy" },
      modTime: { value: null, filterKey: "modTime" },
      ratePlanTitle: { value: null, filterKey: "ratePlanTitle" },
      maxDays: { value: null, filterKey: "maxDays" },
    };

    // If we have saved filters, merge them with defaults
    if (savedTableState?.filters) {
      const savedFilters = savedTableState.filters;
      Object.keys(savedFilters).forEach(key => {
        if (defaultFilters[key]) {
          defaultFilters[key] = { ...defaultFilters[key], ...savedFilters[key] };
        }
      });
    }

    return defaultFilters;
  };

  const filters = getInitialFilters();

  const getToastProps = () => {
    let toastTitle = "";
    if (isPrintError) {
      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle:
          "Unable to open print window. Please check your popup blocker settings.",
        shouldShowToast: true,
      };
    }
if (isRateAdminLorAdjustmentsDeleteSuccess) {
    return {
      severity: TOAST_SEVERITY.SUCCESS,
      toastTitle: "LOR Adjustment deleted successfully!",
      shouldShowToast: true,
    };
  }
  if (isRateAdminLorAdjustmentsDeleteError) {
    return {
      severity: TOAST_SEVERITY.ERROR,
      toastTitle: "Error while deleting LOR Adjustment!",
      shouldShowToast: true,
    };
  }
  if (isCopy) {
      let toastTitle = "Data copied to clipboard!";
      if (!isCopy) {
        toastTitle = "Error while Data copied to clipboard!";
      }

      return {
        severity: isCopy ? TOAST_SEVERITY.SUCCESS : TOAST_SEVERITY.ERROR,
        toastTitle,
        shouldShowToast: true,
      };
    }
  };

  const tableProps = {
    areFiltersVisible,
    columns: tableData?.columns,
    paginationInfo,
    screenPermissions,
    value: tableData?.rows,
    emptyMessage: "No Lor Adjustments found.",
    filters,
    loadLazyData: fetchRateAdminLorAdjustmentss,
    loading: isLoading,
    showMoreActions: false,
    sortField: savedTableState?.sortField || 'id',
    initialSortOrder: savedTableState?.sortOrder,
    initialFirst: savedTableState?.first || 0,
    initialRows: savedTableState?.rows || 10,
    onTableStateChange,
    setDeleteConfirmationPopupVisibility,
    onEditRecord: editRateAdminLorAdjustmentsRoute,
    showViewButton: false,
    shouldOpenDeleteConfirmationPopup,
    onDeleteRecord: deleteRateAdminLorAdjustments,
    showCopyButton: false,
    showDeleteButton: true,
    showEditButton: true,
  };
  return (
    <>
      <Container maxWidth="lg">
        <Breadcrumb list={RateAdminBreadcrumb} />
        <EzToast {...getToastProps()} />
        <div className={`containerbox ${classes.bg}`}>
          {renderPageHeaderSection()}
          <div className="mTop15">
            {shouldRenderFullPageError() && (
              <EzNotFound
                messageStyle={{ marginLeft: "-70px" }}
                bgImgUrl={getIconPath("something-broke.png")}
                message={"Oops! Something broke, we are working on a fix."}
              />
            )}
            {shouldRenderComplianceRecords() && (
              <Box>
                <EzTable {...tableProps} />
              </Box>
            )}
            {shouldRenderNotFoundView() && (
              <EzNotFound
                bgImgUrl={getIconPath()}
                message={"No Lor Adjustments records to show"}
              />
            )}
          </div>
        </div>
      </Container>
    </>
  );
};
export default RateAdminLorAdjustments;
